/* eslint-disable */
import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import Select from 'react-select';
import 'chart.js/auto';
import './benchReleaseForecast.scss';

const BenchReleaseForecast = () => {
  const [selectedOption, setSelectedOption] = useState({ value: 'monthly', label: 'Monthly' });

  const filterOptions = [
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'yearly', label: 'Yearly' },
  ];

  const data = {
    labels: ['FE Dev', 'BE Dev', 'PMO', 'Quality', 'Design', 'Finance', 'Other'],
    datasets: [
      {
        label: 'Release Forecast - Junior',
        data: [4, 3, 2, 5, 6, 7, 4],
        backgroundColor: '#E8A700',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Release',
      },
      {
        label: 'Release Forecast - Mid Level',
        data: [1, 1, 1, 3, 4, 2, 2],
        backgroundColor: '#F1CB69',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Release',
      },
      {
        label: 'Release Forecast - High',
        data: [5, 3, 2, 7, 5, 6, 3],
        backgroundColor: '#FDE9B6',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Release',
      },
      {
        label: 'Bench Forecast - Junior',
        data: [1, 1, 1, 1, 2, 1, 1],
        backgroundColor: '#009042',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Bench',
      },
      {
        label: 'Bench Forecast - Mid Level',
        data: [1, 2, 1, 1, 2, 3, 1],
        backgroundColor: '#36BF74',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Bench',
      },
      {
        label: 'Bench Forecast - High',
        data: [3, 3, 2, 4, 3, 4, 2],
        backgroundColor: '#8FE8BE',
        borderRadius: 10,
        barThickness: 30,
        stack: 'Bench',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, 
      },
      tooltip: {
        backgroundColor: '#FFFFFF',
        titleColor: '#1D1B20',
        bodyColor: '#888888',
        borderColor: '#DDD',
        borderWidth: 1,
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          color: '#e0e0e0',
        },
        ticks: {
          stepSize: 5, 
          min: 0, 
          max: 20,
          callback: (value) => value,
        },
      },
    },
  };
  

  return (
    <div className="forecast-container">
    <div className="header">
    <h2 className="title" style={{ fontSize: '18px' }}>
  Bench and Release Forecast - Experience Distribution
</h2>
  <div className="header-row">
    <p className="date">December 2024</p>
    <Select
  className="filter-dropdown"
  classNamePrefix="custom-dropdown" 
  value={selectedOption}
  onChange={setSelectedOption}
  options={filterOptions}
/>
  </div>
</div>


      <div className="chart-container">
        <Bar data={data} options={options} />
        <div className="custom-legend" style={{ display: 'flex', justifyContent: 'space-between', flexDirection:'row',alignItems: 'center', marginTop: '20px' }}>
  <div className="legend-items" style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
    <div className="legend-item" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div className="vertical-bar release" style={{ backgroundColor: '#E8A700', width: '4px', height: '20px', borderRadius: '2px' }}></div>
      <span style={{ fontSize: '12px', color: '#555' }}>Release Forecast</span>
    </div>
    <div className="legend-item" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div className="vertical-bar bench" style={{ backgroundColor: '#009042', width: '4px', height: '20px', borderRadius: '2px' }}></div>
      <span style={{ fontSize: '12px', color: '#555' }}>Bench Forecast</span>
    </div>
  </div>

  <p className="legend-note" style={{ margin: '0', fontSize: '12px', color: '#555' }}>
    Note: * denotes multi-skilled employees
  </p>
</div>



      </div>
    </div>
  );
};

export default BenchReleaseForecast;
